import { useNavigate } from "react-router-dom";

type Props = {
  company_name: string;
};

export const EmployeeLinkModal = ({ company_name }: Props) => {
  const navigate = useNavigate();

  const onClose = () => {
    navigate("/home");
  };

  return (
    <div
      className="fixed flex items-center justify-center z-50 inset-0 h-screen overflow-y-hidden bg-[#00000075]"
      aria-labelledby="modal-title"
      aria-modal="true"
    >
      <div
        className="flex flex-col items-center space-y-4 bg-white dark:bg-neutral-800
          rounded-lg shadow-lg p-8 max-w-lg
          "
      >
        <h2 className="text-2xl font-semibold text-neutral-900 text-center dark:text-neutral-100">
          Parabéns! 🎉 Seu vínculo com a empresa {company_name} foi confirmado.
        </h2>
        <p className="mt-4 text-neutral-600 text-center dark:text-neutral-400">
          Você pode continuar a navegar e aproveitar novas experiências.
        </p>

        <button
          onClick={onClose}
          className="mt-8 px-6 py-3 text-white uppercase bg-primary-500 hover:bg-primary-600 rounded-md"
        >
          Continuar
        </button>
      </div>
    </div>
  );
};
